import { getSpaceValue } from './getSpaceValue';
export var sumSpace = function (first, second) {
    if (first === void 0) { first = 'none'; }
    if (second === void 0) { second = 'none'; }
    var firstValue = getSpaceValue(Array.isArray(first) ? first[0] : first);
    var secondValue = getSpaceValue(Array.isArray(second) ? second[0] : second);
    return firstValue + secondValue;
};
